import { PublicationApprovalStatus } from "generated/CoreApi_v1";
import { useCardContext } from "../../CardBuilder";
import { DefaultModerationClassification } from "../common/DefaultModerationClassification";
import { ThreadItemClassification } from "../common/ThreadItemClassification";

export const FeedMyContributionsThreadClassification = () => {

    const { pub } = useCardContext();

    if (pub.approvalStatus != PublicationApprovalStatus.Approved)
        return <DefaultModerationClassification />;

    return <ThreadItemClassification />;
};
